import { defineField, defineType } from "sanity";

export const clientCarePage = defineType({
  name: "clientCarePage",
  title: "Client Care Page",
  type: "document",
  fields: [
    defineField({
      name: "slug",
      title: "Page",
      type: "string",
      options: {
        list: [
          { title: "Returns", value: "returns" },
          { title: "Shipping", value: "shipping" },
          { title: "Sizing", value: "sizing" },
          { title: "FAQ", value: "faq" },
          { title: "Foundations & Donations", value: "foundations-and-donations" },
          { title: "Custom", value: "custom" }
        ]
      },
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "title",
      title: "Title",
      type: "string"
    }),
    defineField({
      name: "body",
      title: "Body",
      type: "array",
      of: [{ type: "block" }]
    }),
    defineField({
      name: "metaTitle",
      title: "Meta title",
      type: "string",
      description: "Page title for search engines."
    }),
    defineField({
      name: "metaDescription",
      title: "Meta description",
      type: "text",
      rows: 3,
      description: "Short description for search engines."
    }),
    defineField({
      name: "ogImage",
      title: "Sharing image",
      type: "image",
      description: "Image shown when this page is shared on social media.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ]
    })
  ],
  preview: {
    select: {
      title: "title",
      subtitle: "slug"
    }
  }
});
